<template>
  <div>
    <span class="table_text">
        <i :class="computedDeviceTextClass"></i>
        {{computedDeviceText}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'base-device-state',
  props: {
    code : {
      required: true,
      type: Number,
      default: () => 0
    },
    type: {
      required: true,
      type: String,
      default: () => 'warning'
    }
  },
  computed: {
    computedDeviceTextClass: {
      get(){
        const texts = {
          drop_out: {
            0: 'state bg_regular',
            1: 'state bg_drop_out'
          },
          warning: {
            0: 'state bg_regular',
            1: 'state bg_warning'
          },
          net_work: {
            0: 'state bg_offline',
            1: 'state bg_regular'
          }
        }

        return texts[this.type][this.code]
      }
    },
    computedDeviceText: {
      get(){
        const texts = {
          drop_out: {
            0: '正常',
            1: '脱扣'
          },
          warning: {
            0: '正常',
            1: '报警'
          },
          net_work: {
            0: '离线',
            1: '在线'
          }
        }

        return texts[this.type][this.code]
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/component/base-device-state.vue